import React from 'react'
import { Redirect } from "react-router-dom"
import { makeStyles } from '@material-ui/core/styles'
import { Grid } from '@material-ui/core'
import UsersManagementTable from '../Components/UsersManagement/UsersManagementTable'
import NavBar from '../Components/NavBar/NavBar'
import { validateSession, validateUser } from '../utils'

const useStyles = makeStyles(() => ({
  main: {
    margin: '8% 5%',
    maxWidth: '90%',
  },
}));

export default function UsersManagement() {
  const classes = useStyles()

  if (!validateSession()) {
    return <Redirect to="/login" />
  }

  return (
    <>
      <NavBar />
      <Grid container className={classes.main}>
        <Grid item xs={12}>
          <UsersManagementTable />
        </Grid>
      </Grid>
    </>
  );
}
